import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const Page: StyleRule = ({ theme }) => ({
    width: '100%',
    background: theme.siteVariables.colorScheme.default?.background,
});

export const Container: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 0, 80]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 50, 130]),
    },

    [theme.screen.clamped]: {
        padding: pxArrayToRem([0, 0, 130]),
    },
});
